'use strict';

function korotko() {
  const slider = document.querySelector('.slider'),
    sliderInner = document.querySelector('.slider-inner'),
    slides = document.querySelectorAll('.item'),
    slideTitle = document.querySelectorAll('.slide_title'),
    korotkoNextBtn = document.querySelector('#korotko_next'),
    korotkoPrevBtn = document.querySelector('#korotko_prev'),
    korotkoNav = document.querySelectorAll('.korotko_nav_btn'),
    mediaMax = window.matchMedia('(max-width: 640px)'),
    width = window.getComputedStyle(slider).width;


  let offset = 0;
  let slideIndex = 0;

  korotkoNav.forEach(nav => {
    if (mediaMax.matches) {
      nav.style.display = 'inline-block';
    } else {
      nav.style.display = 'none';
    }
  });

  function showOneTitle() {
    slideTitle.forEach(title => title.style.display = 'none');

    slideTitle[slideIndex].style.display = 'inline-block';
  }

  function go() {

    let nextSlide = setTimeout(moveOver, 5000);

    slider.addEventListener('mouseenter', () => {
      clearTimeout(nextSlide);
      korotkoNav.forEach(btn => {
        btn.style.display = 'inline-block';
      });
    });
  }
  
  sliderInner.style.width = 100 * slides.length + '%';
  sliderInner.style.display = 'block';
  sliderInner.style.transition = '0.5s all';

  function toTheNext() {
    if (slideIndex == slides.length - 1) {
      offset = 0;
    } else {
      offset += +width.slice(0, width.length - 2);
    }

    sliderInner.style.transform = `translateX(-${offset}px)`;

    if (slideIndex == slides.length - 1) {
      slideIndex = 0;
    } else {
      slideIndex++;
    }

    showOneTitle();
  }

  function prevKorotkoSlide() {
    if (slideIndex == 0) {
      offset = +width.slice(0, width.length - 2) * (slides.length - 1);
    } else {
      offset -= +width.slice(0, width.length - 2);
    }

    sliderInner.style.transform = `translateX(-${offset}px)`;

    if (slideIndex == 0) {
      slideIndex = slides.length - 1;
    } else {
      slideIndex--;
    }

    showOneTitle();
  }

  slides.forEach(slide => {
    slide.style.width = width;
  });

  slider.style.overflow = 'hidden';

  showOneTitle();
  
  go();

  slider.addEventListener('mouseleave', () => {
    if (!mediaMax.matches) {
      korotkoNav.forEach(btn => {
        btn.style.display = 'none';
      });
    }
    go();
  });

  function moveOver() {
    toTheNext();

    go();
  }

  korotkoNextBtn.addEventListener('click', () => {

    toTheNext();
  });

  korotkoPrevBtn.addEventListener('click', () => {
    prevKorotkoSlide();
  });
}

export default korotko;